import ManageMembersController from '../modals/manage_members_controller'
import EmailPromptController from '../modals/email_prompt_controller'
import { Loader } from '../common/loader'
import Events from '../../events'

const WorkspacePeopleList = function ($location, $scope, $element, featureToggles, ModalService, workspaceInteractor,
                                      initialDataInteractor) {
  const $ctrl = this;

  $ctrl.$onInit = function () {
    $ctrl.loader = new Loader($element[0]);
    $scope.featureEnabled = (feature) => featureToggles.isAvailable(feature);
    $scope.$on(Events.LOAD_COMPLETE, () => {
      $ctrl.loader.remove();
      $ctrl.loaded = true;
    })
  };

  $ctrl.invite = function () {
    ModalService.showModal({
      templateUrl: 'modals/email_prompt.html',
      controllerAs: '$ctrl',
      controller: EmailPromptController,
      inputs: {
        submitEmail: email => console.log('Email submitted:', email)
      }
    });
  };

  this.userClickedName = function (person) {
    $scope.$evalAsync(() => {
      let path = '/coachee/' + person.id;
      $location.path(path);
    });
  };

  this.makeChangeRequest = function (newList) {
    return workspaceInteractor.updateWorkspace(newList.map(m => m.id), $ctrl.workspace.id, $ctrl.workspace.name)
      .then(() => {
        $ctrl.workspace.members = newList;
        $scope.$digest();
      });
  };

  this.manage = function () {
    ModalService.showModal({
      templateUrl: 'modals/manage_members.html',
      controllerAs: '$ctrl',
      controller: ManageMembersController,
      inputs: {
        members: $ctrl.workspace.members,
        requestChangeToList: $ctrl.makeChangeRequest,
        initialDataInteractor: initialDataInteractor
      }
    })
  }
};

export default {
  name: 'workspacePeopleList',
  obj: {
    controller: WorkspacePeopleList,
    templateUrl: 'components/workspace_people_list.html',
    bindings: {
      workspace: '<'
    }
  }
};